import React, {Component} from "react";

export default class ImageSourceError extends Component {

    state = {
        visible: false
    }

    show = () => {this.setState({visible: true})}
    hide = () => {this.setState({visible: false})}

    render() {
        return this.state.visible ? <div className="error error-message">Source is not image</div> : null;
    }
}